<template>
    <app-tooltip v-if="visible" :value="tooltipValue">
        <edit-boolean
            v-model="inputValue"
            v-test-id="`toggle_panel_offers`"
            :disabled="disabled"
            :label="$t('panel')"
            type="switch"
            :hide-details="true"
            color="primaryText"
            class="app-toggle"
        />
    </app-tooltip>
</template>

<script>
export default {
    name: 'AppTogglePanelOffers',
    props: {
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        visible() {
            if (this.isGrowthInvest()) {
                return true;
            }

            if (this.isProvider()) {
                return true;
            }

            if (this.isCompany()) {
                return true;
            }

            if (this.isAdviser() && this.isSuperuser()) {
                return true;
            }

            return false;
        },
        inputValue: {
            get() {
                return this.$store.getters['preferences/show_approved_panel_only'];
            },
            set() {
                this.$store.dispatch('preferences/toggleShowApprovedPanelOnly');
            }
        },
        tooltipValue() {
            return this.inputValue
                ? this.$t('switch_off_to_show_off_panel_products')
                : this.$t('switch_on_to_show_your_approved_panel');
        }
    }
};
</script>
